module.exports = __webpack_public_path__ + "img/macro_On.dc2ed92e.png";